import { NgOtpInputConfig } from 'ng-otp-input';

const baseOtpStyles = {
  inputStyles: {
    width: '50px',
    height: '50px',
    'border-radius': '8px',
    border: '1px solid #0000001a',
    'font-size': '18px',
    'font-weight': '600'
  },
  containerStyles: {
    display: 'flex',
    'justify-content': 'space-between',
    gap: '10px'
  }
};

export const OTP_CONFIG_6_DIGIT: NgOtpInputConfig = {
  length: 6,
  allowNumbersOnly: true,
  ...baseOtpStyles
};

export const OTP_CONFIG_8_DIGIT: NgOtpInputConfig = {
  length: 8,
  allowNumbersOnly: false,
  ...baseOtpStyles
};
